import PanelMessages from "../../components/PanelMessages";

export default function ParentMessages() {
  return <PanelMessages apiPrefix="parent" />;
}
